import { useMemo } from 'react'
import { usePermissions } from '@/lib/permissions'
import { V2_NAV, type V2NavGroup, type V2NavItem } from './nav-config'
import { filterNavGroups, flattenNavLeaves } from './nav-visibility'

/**
 * 현재 사용자가 볼 수 있는 v2 네비 (FIKET-417) — 권한 없는 항목·빈 그룹 제거. ADMIN 은 전체.
 * `flat` 은 실제 페이지(리프)만 — 2단계 자식은 "부모 자식" 라벨로 합성되어 탑바 검색·홈 바로가기에 쓰인다.
 */
export function useVisibleNav(): { groups: V2NavGroup[]; flat: V2NavItem[] } {
  const { canViewPath } = usePermissions()
  return useMemo(() => {
    const groups = filterNavGroups(V2_NAV, canViewPath)
    return { groups, flat: flattenNavLeaves(groups) }
  }, [canViewPath])
}
